import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const EngineListingCardSkeleton = () => {
  return (
    <Card className="overflow-hidden animate-pulse">
      <CardContent className="p-0">
        {/* Hero Image Skeleton */}
        <Skeleton className="w-full aspect-video" />
        
        {/* Content */}
        <div className="p-4 sm:p-6 space-y-4">
          {/* Title and badges */}
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-20" />
              <Skeleton className="h-5 w-24" />
            </div>
            <Skeleton className="h-6 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>

          {/* Price */}
          <Skeleton className="h-8 w-32" />

          {/* Specs Grid */}
          <div className="grid grid-cols-2 gap-3">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="space-y-2">
                <Skeleton className="h-4 w-16" />
                <Skeleton className="h-5 w-24" />
              </div>
            ))}
          </div>

          {/* Buttons */}
          <div className="flex gap-2 pt-2">
            <Skeleton className="h-10 flex-1" />
            <Skeleton className="h-10 w-10" />
            <Skeleton className="h-10 w-10" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
